import { CloudCommand } from "../types.js";

export const createConversation: CloudCommand = {
    action: "CONVERSATION/CREATE",
    commandName: "conversation.createConversation",
    buildPayload: ({ params }) => params,
};
